// extracted by mini-css-extract-plugin
export var hideEditor = "_q3-2";
export var infoIcon = "_q3-3";
export var label = "_q3-1";
export var labelContainer = "_q3-0";
export var readonlyText = "_q3-4";